import { createFileRoute } from '@tanstack/react-router'
import { AICostsPage } from '@/pages/ai-costs'

export const Route = createFileRoute('/_authenticated/ai-costs')({
  staticData: { title: 'AI Costs' },
  component: AICostsPage,
})
